import { Dropdown, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { DeleteIconSm, EditIcon } from '../../Globle/Icon';
import { AiOutlineExpandAlt } from 'react-icons/ai';
import DeleteModel from '../../Globle/DeleteModel';

const ClosetList = observer(() => {
    const { viewManager, closetManager, drawingManager } = useMainContext();
    const [isOpen, setIsOpen] = useState(false);
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [selectedCloset, setSelectedCloset] = useState(null);
    const isVisible = viewManager.doUserHasAccess();

    const handleDelete = (closet) => {
        if (drawingManager.isDrawingModeOn) {
            message.error("Can't do this operation while drawing mode is on.");
            return;
        }
        setIsModelOpen(true);
        setSelectedCloset(closet);
    };
    const handleCancel = () => {
        setIsModelOpen(false);
        setSelectedCloset(null);
    };
    const handleConfirmDelete = () => {
        closetManager.removeClosetById(selectedCloset._id);
        closetManager.drawNewClosets();
        message.success('Closet deleted successfully.');
        handleCancel();
    };
    const handleFitToScreen = async (closetId) => {
        await closetManager.showClosets(closetId);
    };

    const handleEdit = (closetId) => {
        viewManager.setClosetForm(true);
        closetManager.setSelectedClosetById(closetId);
    };

    const renderMenu = () => {
        return (
            <div className="p-[8px] bg-theme-white w-[200px] shadow-card rounded-[8px]">
                <div className="flex flex-col gap-[4px] max-h-[340px] pr-[4px] overflow-y-auto">
                    {closetManager?.closets?.length > 0 ? (
                        [...closetManager.closets].map((closet, index) => (
                            <div
                                key={closet._id || index}
                                className="bg-transparent group rounded-[8px] p-[8px] cursor-pointer transition-all duration-300 ease-in-out flex items-center justify-between hover:bg-[#9CA3AF66]">
                                <span className="text-[14px] font-favorit font-[400] leading-[21px]">
                                    {closet.name || `Closet ${index + 1}`}
                                </span>
                                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out flex gap-[4px] items-center">
                                    <div
                                        className="cursor-pointer"
                                        onClick={() =>
                                            handleFitToScreen(closet._id)
                                        }>
                                        <AiOutlineExpandAlt className="text-[20px]" />
                                    </div>
                                    {isVisible && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleEdit(closet._id);
                                            }}>
                                            <EditIcon />
                                        </div>
                                    )}
                                    {isVisible && (
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                handleDelete(closet)
                                            }>
                                            <DeleteIconSm />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <span className="text-[14px] font-favorit leading-[21px] text-center">
                            No closets Available
                        </span>
                    )}
                </div>
            </div>
        );
    };
    return (
        <>
            <Dropdown
                open={isOpen}
                onOpenChange={setIsOpen}
                disabled
                placement="top"
                dropdownRender={renderMenu}
                trigger={['click']}>
                <div className="flex items-center gap-[8px]">
                    <span
                        className={`text-[16px] font-favorit ${isOpen ? 'font-[700]' : ''}`}>
                        Closets
                    </span>
                    <span
                        className={`inline-block w-[24px] h-[24px] text-[12px] pt-[2px] pr-[2px] rounded-full ${isOpen ? 'bg-theme-orange' : 'bg-theme-stroke'} text-theme-white flex items-center justify-center`}>
                        {closetManager?.closets?.length || 0}
                    </span>
                    {/* {isOpen ? (
                        <IoIosArrowUp size={20} />
                    ) : (
                        <IoIosArrowDown size={20} />
                    )} */}
                </div>
            </Dropdown>
            <DeleteModel
                isOpen={isModelOpen}
                onClose={() => {
                    handleCancel();
                }}
                name={selectedCloset?.name}
                onConfirm={() => handleConfirmDelete()}
            />
        </>
    );
});

export default ClosetList;
